export default __webpack_public_path__ + "static/heroSectionBg-88f151008ec6eab4dcb3b7d9235ec1b3.png";